
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news-media",
      function () {
        return require("private-next-pages/news-media.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news-media"])
      });
    }
  